// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/fr"
import About from "src/components/pages/About/About"

const AboutPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `aboutPage.sections`, [])
  const teamMembers = _.get(data, `teamMembers.nodes`, [])
  const advisors = _.get(data, `advisors.nodes`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.aboutPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <About
        sections={sections}
        teamMembers={teamMembers}
        advisors={advisors}
      />
    </Layout>
  )
}

export default AboutPageFr

export const query = graphql`
  query AboutPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    aboutPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    teamMembers: allStrapiTeamMember(filter: { locale: { eq: "fr" } }) {
      nodes {
        id
        shortName
        longName
        role
        bio {
          data {
            bio
          }
        }
        avatar {
          url
        }
      }
    }

    advisors: allStrapiAdvisor(filter: { locale: { eq: "fr" } }) {
      nodes {
        longName
        bio {
          data {
            bio
          }
        }
      }
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
